var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1647,
    height: 481,
    viewBox: "0 0 1647 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_142:2582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.572 308.996C118.143 329.945 127.964 347.098 146.034 360.455C164.104 373.812 187.544 380.491 216.356 380.491C242.017 380.491 262.839 375.646 278.819 365.957C294.8 356.268 302.79 343.306 302.79 327.07C302.79 313.45 299.122 303.234 291.785 296.424C284.449 289.614 274.628 284.77 262.324 281.891C250.011 279.02 231.021 276.013 205.352 272.871C170.264 268.684 141.325 263.047 118.534 255.958C95.744 248.87 77.4112 237.595 63.5355 222.134C49.6373 206.717 42.6879 185.911 42.6879 159.716C42.6879 135.106 49.6257 113.237 63.5014 94.1068C77.3771 74.977 96.4958 60.1804 120.857 49.7172C145.226 39.239 172.857 34 203.751 34C254.556 34 295.803 45.2749 327.493 67.8248C359.183 90.3747 376.34 122.065 378.963 162.895H296.464C294.367 144.577 285.201 129.518 268.965 117.716C252.729 105.915 232.314 99.996 207.719 99.9585C183.087 99.9585 163.168 104.671 147.962 114.097C132.756 123.523 125.161 136.358 125.176 152.601C125.176 164.628 128.971 173.648 136.563 179.661C144.155 185.674 153.716 189.865 165.247 192.232C176.762 194.593 195.354 197.34 221.024 200.475C255.6 204.15 284.671 209.788 308.235 217.387C331.8 224.986 350.66 237.035 364.813 253.534C378.952 270.026 386.021 292.418 386.021 320.711C386.021 345.854 378.689 367.987 364.024 387.109C349.359 406.231 329.192 420.889 303.522 431.081C277.861 441.296 249.053 446.404 217.1 446.404C163.138 446.404 119.542 434.223 86.3106 409.862C53.0795 385.5 35.9264 351.848 34.8516 308.906L116.572 308.996Z",
    fill: "#F5F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.426 361.743V42.4926H895.502V438.029H1200.63V361.743H977.426Z",
    fill: "#F5F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 118.779V42.4926H1305.61V438.029H1387.54V271.87H1613V195.584H1387.54V118.779H1613Z",
    fill: "#F5F4F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_142:2582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.714 34H491.225V110.117H713.96V186.774H795.714V34Z",
    fill: "#F5F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.96 186.474H491.225V262.591H713.96V186.474Z",
    fill: "#F5F4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.225 352.285V428.413H795.714V262.599H713.96V352.285H491.225Z",
    fill: "#F5F4F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_142:2582",
    x: 0.851562,
    y: 0,
    width: 1646.15,
    height: 480.404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    result: "effect1_foregroundBlur_142:2582"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_142:2582",
    x: 484.225,
    y: 27,
    width: 318.49,
    height: 408.413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_142:2582"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLogo);
export default __webpack_public_path__ + "static/media/home-logo.468726f71a6c18b0485a73bbad6aa016.svg";
export { ForwardRef as ReactComponent };